const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')

listen('#buttonBackPreContractDetaill', 'click', (e) => {
  const trigger = e.delegateTarget || e.currentTarget
  const defaultUrl = is.getAttributeValue(trigger, 'defaultUrl')
  const previousUrl = document.referrer

  if (previousUrl.indexOf('tramites') >= 0) {
    window.history.back()
  }
  else {
    window.location.href = defaultUrl
  }
})

if (document.getElementById('buttonCSV')) {
  document.getElementById('buttonCSV').addEventListener('click', () => {
    document.getElementById('inputCSV').click()
  })
  document.getElementById('inputCSV').addEventListener('change', (e) => {
    const form = document.getElementById('formCSV')
    const uploadFile = e.target
    if (uploadFile.value.length === 0) {
      alert('Por favor, especifique la ruta al archivo a cargar!')
      return
    }
    form.encoding = 'multipart/form-data'
    form.submit()
  })
}

listen('.buttonArchiveBankPage', 'click', e => {
  const trigger = e.delegateTarget || e.currentTarget
  const page = is.getAttributeValue(trigger, 'page')

  if (is.node(`#formArchiveBankPage${page}`)) {
    is.getNode(`#formArchiveBankPage${page}`).submit()
  }
})

listen('.buttonVerifyBankPage', 'click', e => {
  const trigger = e.delegateTarget || e.currentTarget
  const page = is.getAttributeValue(trigger, 'page')

  if (is.node(`#formVerifyBankPage${page}`)) {
    is.getNode(`#formVerifyBankPage${page}`).submit()
  }
})
